__turbopack_context__.v({
  "circle": "WalletConfirmed-module__ko6aWq__circle",
  "root": "WalletConfirmed-module__ko6aWq__root",
  "unconfirmed": "WalletConfirmed-module__ko6aWq__unconfirmed",
});
